import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

// Base styles for li element
export const liBaseStyle = css`
  color: ${theme.colors.neutral90};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${theme.fontSize(16)};
  line-height: 1.375;
  padding: ${theme.spacing(1, 2)};
`;

// When not disabled, add hover and focus states
export const liInteractiveStyle = css`
  &:hover,
  &[data-focused='true'] {
    background: ${theme.colors.neutral5};
  }
`;

// When disabled
export const liDisabledStyle = css`
  color: ${theme.colors.neutral20};
  cursor: not-allowed;
`;

// Base styles for icon
export const iconBaseStyle = css`
  flex-shrink: 0;
  margin-left: ${theme.spacing(2)};
`;

// Icon visibility states
export const iconSelectedStyle = css`
  visibility: visible;
`;

export const iconNotSelectedStyle = css`
  visibility: hidden;
`;
